import moment from "moment";
import PropTypes from "prop-types";
import React, { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import { withStyles, useTheme } from "@material-ui/core/styles";
import BuildIcon from "@material-ui/icons/Build";
import CloseIcon from "@material-ui/icons/Close";

import Typography from "../../../../components/Helpers/Typography";
import SPScrollbar from "../../../../components/Navigation/SPScrollbar";
import { FleetContext } from "../../../../context";
import useMediaQuery from "../../../../hooks/useMediaQuery";
import API from "../../../../API";

// eslint-disable-next-line import/no-cycle
import CommandListItem from "./CommandListItem";

const styles = (theme) => ({
  dialog: {
    color: theme.palette.text.primary,
  },
  dialogIcon: {
    color: theme.palette.text.primary,
    height: 40,
    width: 40,
    margin: 10,
  },
  formattedEvent: {
    paddingBottom: 14,
    marginBottom: 0,
    fontFamily: "Roboto",
    backgroundColor: theme.palette.primary.main,
  },
  container: {
    margin: "0",
    width: "100%",
    paddingRight: 0,
    paddingTop: 12,
    paddingBottom: 12,
  },
  blueButton: {
    color: theme.palette.text.blue,
    background: "none",
    border: "none",
    textTransform: "uppercase",
    cursor: "pointer",
  },
  lastRefreshed: {
    background: "#08090D",
    paddingTop: 16,
    paddingBottom: 16,
    display: "flex",
    justifyContent: "flex-end",
  },
});

const NoHistory = () => {
  const { t } = useTranslation();
  const typographyStyle = {
    textAlign: "center",
    width: "100%",
  };

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <Typography style={typographyStyle}>{t("Vehicles.Detail.Modals.LogsUnavailable")}</Typography>
      <br />
      <Typography style={typographyStyle} color="secondary">
        {t("Vehicles.Detail.Modals.LogsUnavailableDetails1")}
      </Typography>
      <Typography style={typographyStyle} color="secondary">
        {t("Vehicles.Detail.Modals.LogsUnavailableDetails2")}
      </Typography>
    </div>
  );
};

export const CommandHistoryModal = (props) => {
  const { activeVehicle } = useContext(FleetContext);
  const [commandHistory, setCommandHistory] = useState([]);
  const [lastUpdated, setLastUpdated] = useState(null);
  const { modalOpen, handleModalClose, classes, modalId, handleModalToggle, vehicleId } = props;
  const { t } = useTranslation();
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const refreshCommandHistory = async (force = false) => {
    const data = await API.commandStatus.getForVehicle(vehicleId, force);
    setCommandHistory(data.results);
    setLastUpdated(new Date());
  };

  useEffect(() => {
    if (modalOpen) refreshCommandHistory();
  }, [modalOpen]);

  return (
    <Dialog
      open={modalOpen}
      onClose={handleModalClose("CommandHistoryModal")}
      aria-labelledby="diagnostic-modal"
      fullWidth
      maxWidth="md"
      classes={{ paper: classes.dialog }}
      id="something-dialog-something1"
      fullScreen={isMobile}
      style={{ zIndex: 9010 }}
    >
      <DialogTitle>
        <Grid container>
          <Grid item xs={10}>
            <Typography
              style={{
                fontWeight: 500,
                fontSize: 20,
                height: "100%",
              }}
              color="lightgrey"
            >
              {t("Vehicles.Detail.Actions.CommandHistory")}
            </Typography>
          </Grid>
          <div
            style={{
              position: "absolute",
              top: 0,
              right: 0,
              height: 60,
              width: 200,
              background: "transparent",
              display: "inline-flex",
              justifyContent: "flex-end",
            }}
          >
            {handleModalToggle && (
              <IconButton onClick={handleModalToggle} className={classes.dialogIcon}>
                <BuildIcon />
              </IconButton>
            )}

            <IconButton onClick={handleModalClose(modalId)} className={classes.dialogIcon}>
              <CloseIcon />
            </IconButton>
          </div>
        </Grid>
      </DialogTitle>
      <DialogContent
        style={{
          backgroundColor: theme.palette.background.dark,
          padding: 0,
          overflow: "hidden",
        }}
      >
        <div className={classes.lastRefreshed}>
          <Typography
            style={{ fontSize: 14, textAlign: "right", marginRight: 20 }}
            color="lightgrey"
          >
            {t("Last updated")} {moment(lastUpdated).format("MMMM DD, YYYY HH:mm:ss")}
          </Typography>
          <button
            type="button"
            onClick={() => {
              refreshCommandHistory(activeVehicle.id, true);
            }}
            className={classes.blueButton}
          >
            <Typography color="blue">{t("Refresh")}</Typography>
          </button>
        </div>

        <SPScrollbar
          style={{
            height: isMobile ? "calc(100vh - 130px)" : 500,
          }}
        >
          {!commandHistory || commandHistory.length === 0 ? (
            <NoHistory />
          ) : (
            commandHistory.map((c) => <CommandListItem key={c.rpc_msg_id} command={c} />)
          )}
        </SPScrollbar>
      </DialogContent>
    </Dialog>
  );
};

CommandHistoryModal.propTypes = {
  classes: PropTypes.object.isRequired,
  modalId: PropTypes.string,
  modalOpen: PropTypes.bool.isRequired,
  handleModalClose: PropTypes.func.isRequired,
  handleModalToggle: PropTypes.func,
  vehicleId: PropTypes.string.isRequired,
};

CommandHistoryModal.defaultProps = {
  modalId: "DiagnosticModal",
  handleModalToggle: null,
};

export default withStyles(styles)(CommandHistoryModal);
